export function negotiationColumnWidths(width: number, compact: boolean): number[] {
    if (!compact || !Number.isFinite(width) || width <= 0) {
        return [45, 150, 220, 140, 150];
    }
    const available = Math.max(4, Math.floor(width));
    const order = Math.max(1, Math.min(28, Math.floor(available * 0.1)));
    const name = Math.max(1, Math.floor(available * 0.24));
    const note = Math.max(1, Math.floor(available * 0.2));
    // Keep all four visible columns inside the viewport. Column 4 stays hidden.
    return [order, name, available - order - name - note, note, 150];
}
